// src/components/Atelier4/ThreatIntelligence.js
// This file exports the modern ThreatIntelligence component for backward compatibility

import ThreatIntelligenceModern from './ThreatIntelligence/index';

export default ThreatIntelligenceModern;
